import { makeStyles } from "$components/mui-styles";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import { INSURER } from "../../InsurerAccordion/formConstants";
import InsurerInvoice from "../PrintableInvoice/InsurerInvoice";
import { getPrintableInvoices } from "../utils";
import PatientLaserReceipt from "./PatientLaserReceipt";

const useStyles = makeStyles({
  containerWrapper: {
    display: "none",
  },
});

// This must be a class to work with react-to-print
class ComponentToPrint extends React.Component {
  render() {
    const { invoice, invoicesToPrint, printReceiptOnly } = this.props;
    if (!invoice) {
      return null;
    }

    if (printReceiptOnly) {
      return <PatientLaserReceipt invoice={invoice} />;
    }

    const invoicesToBePrinted = getPrintableInvoices(
      invoicesToPrint,
      invoice?.payers,
    );

    if (invoicesToBePrinted?.length > 0) {
      return (
        <div>
          {invoicesToBePrinted.map((insurerInvoice) => {
            if (insurerInvoice?.type === INSURER) {
              return (
                <InsurerInvoice
                  invoice={invoice}
                  insurer={insurerInvoice}
                  key={insurerInvoice?.type}
                />
              );
            }
            return (
              <PatientLaserReceipt
                invoice={invoice}
                key={insurerInvoice?.type}
              />
            );
          })}
        </div>
      );
    }
    return <PatientLaserReceipt invoice={invoice} />;
  }
}

ComponentToPrint.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  invoice: PropTypes.shape({
    invoiceNumber: PropTypes.string,
    payers: PropTypes.arrayOf(PropTypes.shape({})),
    patient: PropTypes.shape({}),
    lineItems: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  invoicesToPrint: PropTypes.arrayOf(PropTypes.string).isRequired,
  printReceiptOnly: PropTypes.bool,
};

ComponentToPrint.defaultProps = {
  printReceiptOnly: false,
};

class ReactToPrintRemoteTrigger extends ReactToPrint {
  // Overrides `ReactToPrint` to remove need for triggerElement in render method
  render() {
    return <div />;
  }
}

const LaserReceiptPrint = (props) => {
  const { onAfterPrint } = props;
  const componentRef = useRef();
  const receiptRef = useRef();
  const classes = useStyles();

  // On didMount - trigger native print
  useEffect(() => {
    receiptRef.current.handleClick();
  }, []);

  return (
    <div data-testid="laser-printing">
      <ReactToPrintRemoteTrigger
        ref={receiptRef}
        content={() => componentRef.current}
        pageStyle="@page{ size: a5; } @media print{ }"
        onAfterPrint={onAfterPrint}
      />
      <div className={classes.containerWrapper}>
        <ComponentToPrint ref={componentRef} classes={classes} {...props} />
      </div>
    </div>
  );
};

LaserReceiptPrint.propTypes = {
  onAfterPrint: PropTypes.func.isRequired,
  invoice: PropTypes.shape({}).isRequired,
  invoicesToPrint: PropTypes.arrayOf(PropTypes.string).isRequired,
  printReceiptOnly: PropTypes.bool,
};

LaserReceiptPrint.defaultProps = {
  printReceiptOnly: false,
};

export default LaserReceiptPrint;
